import React from "react";
import useBaggageInfoController from "./useBaggageInfo.controller";
import { UIFlightData } from "@flights/types";
import { Stack } from "@bookingcom/bui-react";
import Frame from "../../../../../Frame";
import BaggagePolicies from "../../../../../BaggagePolicies";
import IncludedBaggageList from "./BaggageInfoList";

const useBaggageInfo = (flight: UIFlightData) => {
  const { header, subheader, includedProducts, baggagePolicies } = useBaggageInfoController(flight);

  if (includedProducts) {
    return {
      header,
      subheader,
      content: (
        <Stack gap={2}>
          {includedProducts && (
            <IncludedBaggageList flightSegments={flight.segments} includedProducts={includedProducts} />
          )}

          {baggagePolicies && (
            <Frame>
              <BaggagePolicies baggagePolicies={baggagePolicies} />
            </Frame>
          )}
        </Stack>
      )
    };
  }

  if (baggagePolicies) {
    return {
      content: (
        <Frame>
          <BaggagePolicies baggagePolicies={baggagePolicies} />
        </Frame>
      )
    };
  }

  return undefined;
};

export default useBaggageInfo;
